<template>
  <div class="fileUnitl" v-show="childFalse">
    <div class="topBox">
      <el-button @click="childback" type="">返回</el-button>
    </div>
    <div class="bottomBox">
      <el-card class="tree-card" :body-style="treeCard">
        <div class="basic">
          <div class="basicTitle">基本信息</div>
          <div class="basicImgbox">
            <div class="basicImg">
              <!-- imageUrl -->
              <img
                v-if="peopleList.imageUrl"
                :src="imgURL + peopleList.imageUrl"
              />
            </div>
            <div class="basicName">
              <div class="basicItem">
                <span>单位名称:</span>
                <span>{{ peopleList.unitName }}</span>
              </div>
              <div class="basicItem">
                <span>单位类别:</span>
                <span>{{ peopleList.unitTypeDict }}</span>
              </div>
              <div class="basicItem">
                <span>重点单位:</span>
                <span>{{ peopleList.keyunitDict }}</span>
              </div>
              <div class="basicItem">
                <span>经济类型:</span>
                <span>{{ peopleList.economicType }}</span>
              </div>
            </div>
          </div>
          <div class="basicItem">
            <span>行业类别:</span>
            <span>{{ peopleList.industryTypeDict }}</span>
          </div>
          <div class="basicItem">
            <span>上级名称:</span>
            <span>{{ peopleList.higherName }}</span>
          </div>
          <div class="basicItem">
            <span>注册资金:</span>
            <span>{{ peopleList.registerMoney }}</span>
          </div>
          <div class="basicItem">
            <span>联系电话:</span>
            <span>{{ peopleList.unitTelphone }}</span>
          </div>
          <div class="basicItem">
            <span>网址:</span>
            <span>{{ peopleList.url }}</span>
          </div>
          <!-- <template v-for="item in dataLable" :key="item.id">
            <div class="basicTitle">{{item.name}}</div>
            <div class="basicItem" v-for="l in item.children" :key="l.prop">
              <span>{{l.label}}:</span>
              <span>{{l.prop}}</span>
            </div>
          </template> -->
          <div class="basicTitle">经营信息</div>
          <div class="basicItem">
            <span>经营名称:</span>
            <span>{{ peopleList.businessName }}</span>
          </div>
          <div class="basicItem">
            <span>英文名称:</span>
            <span>{{ peopleList.unitEnglishName }}</span>
          </div>
          <div class="basicItem">
            <span>英文缩写:</span>
            <span>{{ peopleList.englishAbbreviation }}</span>
          </div>
          <div class="basicItem">
            <span>开业日期:</span>
            <span>{{ peopleList.startdate }}</span>
          </div>
          <div class="basicItem">
            <span>停业日期:</span>
            <span>{{ peopleList.enddate }}</span>
          </div>
          <div class="basicItem">
            <span>经营面积:</span>
            <span>{{ peopleList.operatingArea }}</span>
          </div>
          <div class="basicItem">
            <span>经营性质:</span>
            <span>{{ peopleList.businessPracticeDict }}</span>
          </div>
          <div class="basicTitle">单位地址</div>
          <div class="basicItem">
            <span>地区:</span>
            <span>{{ peopleList.unitAddress }}</span>
          </div>
          <div class="basicItem">
            <span>详细地址:</span>
            <span>{{ peopleList.unitAddressInfo }}</span>
          </div>
          <div class="basicTitle">注册地址</div>
          <div class="basicItem">
            <span>地区:</span>
            <span>{{ peopleList.registeredAddress }}</span>
          </div>
          <div class="basicItem">
            <span>详细地址:</span>
            <span>{{ peopleList.registeredAddressInfo }}</span>
          </div>
          <div class="basicTitle">经营执照</div>
          <div class="basicItem">
            <span>起始日期:</span>
            <span>{{ peopleList.licenseStartdate }}</span>
          </div>
          <div class="basicItem">
            <span>截止日期:</span>
            <span>{{ peopleList.licenseEnddate }}</span>
          </div>
          <div class="basicTitle">经营范围</div>
          <div class="basicItem">
            <span>主营:</span>
            <span>{{ peopleList.businessScope }}</span>
          </div>
          <div class="basicItem">
            <span>兼营:</span>
            <span>{{ peopleList.businessSideline }}</span>
          </div>
          <div class="basicTitle">法定代表人</div>
          <div class="basicItem">
            <span>姓名:</span>
            <span>{{ peopleList.legalName }}</span>
          </div>
          <div class="basicItem">
            <span>外文姓:</span>
            <span>{{ peopleList.englishSurname }}</span>
          </div>
          <div class="basicItem">
            <span>外文名:</span>
            <span>{{ peopleList.englishName }}</span>
          </div>
          <div class="basicItem">
            <span>证件类型:</span>
            <span>{{ peopleList.legalCardTypeDict }}</span>
          </div>
          <div class="basicItem">
            <span>证件号码:</span>
            <span>{{ peopleList.legalCardNum }}</span>
          </div>
          <div class="basicItem">
            <span>联系电话:</span>
            <span>{{ peopleList.legalTelphone }}</span>
          </div>
          <div class="basicTitle">保卫负责人</div>
          <div class="basicItem">
            <span>姓名:</span>
            <span>{{ peopleList.mainName }}</span>
          </div>
          <div class="basicItem">
            <span>身份证号:</span>
            <span>{{ peopleList.mainCardNum }}</span>
          </div>
          <div class="basicItem">
            <span>联系电话:</span>
            <span>{{ peopleList.mainTelphone }}</span>
          </div>
          <!--  -->
        </div>
      </el-card>
      <div class="rightcenter">
        <commentright
          :dialogCount="peopleList"
          :showType="showType"
        ></commentright>
      </div>
      <!-- <div class="center-card" :body-style="treeCard">
        <div class="centerbg">
          <div class="imgone">
            <img src="@/assets/images/threeSolid/threecor.png" />
          </div>
          <div class="imgtwo">
            <img src="@/assets/images/threeSolid/threecor.png" />
          </div>
          <div class="imgthree">
            <img src="@/assets/images/ceicon.png" />
          </div>
          <div class="centerbtn">
            <div class="btnitem"
            @click="clickCenter(item)"
            v-for="item in peopleList.furtherList" :key="item.type">
              {{item.name}}
            </div>
          </div>
        </div>
      </div>
      <el-card class="tree-card" :body-style="treeCard">
        <div class="basic">
          <div class="basicTitle">基本信息</div>
          <div class="basicItem">
            <span>证件类型:</span>
            <span>中国</span>
          </div>
        </div>
      </el-card> -->
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect, nextTick } from "vue";
import { infoQuery } from "@/api/threeSolid/fileManagement";
// import { houseright, carright } from './fileManagement';
import commentright from "./commentright";
export default defineComponent({
  name: "",
  components: { commentright },
  props: {
    grandsonVisible: {
      type: Boolean,
    },
    showType: {
      type: String,
    },
    prisonId: {
      type: Number,
      default: 1,
    },
  },
  setup(props, context) {
    const data = reactive({
      imgURL: window.imgURL,
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      childFalse: false,
      prisonIds: 0,
      peopleList: {},
      dataLable: [
        {
          name: "经营信息",
          id: 2,
          children: [
            {
              label: "经营名称",
              prop: "carNumber",
            },
          ],
        },
        {
          name: "单位地址",
          id: 3,
          children: [
            {
              label: "车牌号",
              prop: "carNumber",
            },
          ],
        },
      ],
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.childFalse = props.grandsonVisible;
    });
    watchEffect(() => {
      context.emit("update:grandsonVisible", data.childFalse);
    });
    watchEffect(() => {
      if (props.prisonId) {
        data.prisonIds = props.prisonId;
        nextTick(() => {
          unitllist();
        });
      }
    });
    const childback = () => {
      data.childFalse = false;
    };
    const unitllist = async () => {
      if (props.showType === "3") {
        const res = await infoQuery(data.prisonIds);
        data.peopleList = res.syUnitInfo;
        console.log(data.peopleList);
      }
    };

    return {
      ...refData,
      childback,
    };
  },
});
</script>
<style lang="scss" scoped>
.rightcenter {
  flex: 1;
}
.fileUnitl {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  display: flex;
  flex-direction: column;
  .topBox {
    line-height: 66px;
    border-bottom: 1px solid #f1f2f5;
    padding: 0 20px;
  }
  .bottomBox {
    display: flex;
    flex: 1;
    overflow: auto;
  }
  .tree-card {
    height: 100%;
    width: 400px;
  }
  .basic {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    .basicTitle {
      color: #000;
      line-height: 40px;
      font-weight: bold;
    }
    .basicImgbox {
      width: 100%;
      height: 180px;
      display: flex;
      .basicImg {
        width: 110px;
        height: 100%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .basicName {
        flex: 1;
      }
    }
    .basicItem {
      flex: 1;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f1f2f5;
      padding: 10px 0;
      line-height: 24px;
      span {
        // width: 206px;
      }
    }
  }
  .center-card {
    flex: 1;
    position: relative;
    .centerbg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 386px;
      height: 386px;
      img {
        width: 100%;
        height: 100%;
      }
      .imgone {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgtwo {
        width: 75%;
        height: 75%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .imgthree {
        width: 50%;
        height: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: url("~@/assets/images/threeSolid/threecor.png");
        background-size: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
    }
    .centerbtn {
      width: 386px;
      height: 386px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .btnitem {
        width: 66px;
        height: 66px;
        text-align: center;
        line-height: 66px;
        border-radius: 100%;
        color: #fff;
        background: #388ff3;
        position: absolute;
        cursor: pointer;
        &:nth-child(1) {
          left: 50%;
          top: -30px;
        }
        &:nth-child(2) {
          left: 75%;
          top: 30px;
        }
        &:nth-child(3) {
          left: 90%;
          top: 50%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 83%;
        }
        &:nth-child(5) {
          left: 35%;
          bottom: -27px;
        }
        &:nth-child(6) {
          left: 20%;
          bottom: 61px;
          width: 45px;
          height: 45px;
          line-height: 42px;
        }
        &:nth-child(7) {
          left: -3%;
          bottom: 24%;
        }
        &:nth-child(8) {
          left: -1%;
          top: 110px;
        }
        &:nth-child(9) {
          left: 10%;
          top: 0px;
        }
      }
    }
  }
}
</style>
